import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import BlockTitle from '@/components/BlockTitle.vue'
import { ElFormItem, ElSwitch, FormInstance, FormRules } from 'element-plus'
import { reactive, ref } from 'vue'
import { LoRaWANProfile, RegionOptions, RegionalParametetsRevisionOptions, MacVersionOptions } from '@/store/profile.interface'
import { NewProfileStore } from '@/store/newProfileStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileLoRaWANForm',
  setup(__props, { expose: __expose }) {

const store = new NewProfileStore()

const lorawanFormRef = ref<FormInstance>()
const lorawanFormRules = ref<FormRules<LoRaWANProfile>>({

})

const lorawan = ref<LoRaWANProfile>(store.GetLoRaWAN())

const Submit = async () => {
  return new Promise<void>((resolve, reject) => {
    lorawanFormRef.value?.validate((isvalid, item) => {
      if (isvalid) {
        resolve()
      } else {
        reject(new Error('Some fields are invalid'))
      }
    })
  })
}

const Load = () => {
  lorawan.value = store.GetLoRaWAN()
}

__expose({ Submit, Load })

return (_ctx: any,_cache: any) => {
  const _component_ElOption = _resolveComponent("ElOption")!
  const _component_ElSelect = _resolveComponent("ElSelect")!
  const _component_ElInputNumber = _resolveComponent("ElInputNumber")!
  const _component_ElForm = _resolveComponent("ElForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BlockTitle, {
      title: "LoRaWAN Parameters",
      description: "Set the LoRaWAN Parameters"
    }),
    _createVNode(_component_ElForm, {
      ref_key: "lorawanFormRef",
      ref: lorawanFormRef,
      rules: "lorawanFormRules",
      model: lorawan.value,
      "label-position": "left",
      "label-width": "auto",
      style: {"width":"600px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElFormItem), { label: "Region" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElSelect, {
              modelValue: lorawan.value.region,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((lorawan.value.region) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RegionOptions)(), (opt) => {
                  return (_openBlock(), _createBlock(_component_ElOption, {
                    key: opt.value,
                    label: opt.label,
                    value: opt.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "LoRaWAN MAC Version" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElSelect, {
              modelValue: lorawan.value.macVersion,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lorawan.value.macVersion) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MacVersionOptions)(), (opt) => {
                  return (_openBlock(), _createBlock(_component_ElOption, {
                    key: opt.value,
                    label: opt.label,
                    value: opt.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "LoRaWAN Regional Parameters Revision" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElSelect, {
              modelValue: lorawan.value.regionalParametetsRevision,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lorawan.value.regionalParametetsRevision) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RegionalParametetsRevisionOptions)(), (opt) => {
                  return (_openBlock(), _createBlock(_component_ElOption, {
                    key: opt.value,
                    label: opt.label,
                    value: opt.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "Supports OTAA" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElSwitch), {
              modelValue: lorawan.value.supportOTAA,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((lorawan.value.supportOTAA) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "Supports Class B" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElSwitch), {
              modelValue: lorawan.value.supportClassB,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((lorawan.value.supportClassB) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "Supports Class C" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElSwitch), {
              modelValue: lorawan.value.supportClassC,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((lorawan.value.supportClassC) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (lorawan.value.supportClassC)
          ? (_openBlock(), _createBlock(_unref(ElFormItem), {
              key: 0,
              label: "Class C Downlink Timeout"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElInputNumber, {
                  modelValue: lorawan.value.classCDownlinkTimeout,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((lorawan.value.classCDownlinkTimeout) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"])
  ], 64))
}
}

})